"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _MenuItem = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/MenuItem"));
var eventHandlerUtils = _interopRequireWildcard(require("../../utils/eventHandlers"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var styles = {
  "action": "action_toOH-b",
  "menu-item": "menu-item_3jVytx",
  "menuItem": "menu-item_3jVytx"
}; 
require('./ActionItem.css');
var ActionItem = /*#__PURE__*/function (_React$PureComponent) {
  function ActionItem() {
    (0, _classCallCheck2.default)(this, ActionItem);
    return _callSuper(this, ActionItem, arguments);
  }
  (0, _inherits2.default)(ActionItem, _React$PureComponent);
  return (0, _createClass2.default)(ActionItem, [{
    key: "renderDescription",
    value: function renderDescription() {
      var _this$props = this.props,
        description = _this$props.description,
        testId = _this$props.testId;
      if (!description || !testId) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement("span", {
        id: testId ? "".concat(testId, "-description") : undefined,
        className: "visually-hidden"
      }, description);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        onClick = _this$props2.onClick,
        children = _this$props2.children,
        className = _this$props2.className,
        href = _this$props2.href,
        testId = _this$props2.testId;
      if (href) {
        return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
          className: styles.menuItem
        }, /*#__PURE__*/_react.default.createElement("a", {
          "data-test-id": testId,
          "aria-describedby": testId ? "".concat(testId, "-description") : undefined,
          className: (0, _classnames.default)(className, styles.action),
          onClick: onClick,
          href: href,
          target: "_blank",
          rel: "noopener noreferrer"
        }, children), this.renderDescription());
      }
      return /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
        className: styles.menuItem
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-test-id": testId,
        role: "button",
        "aria-describedby": testId ? "".concat(testId, "-description") : undefined,
        className: (0, _classnames.default)(className, styles.action),
        tabIndex: "0",
        onClick: onClick,
        onKeyDown: eventHandlerUtils.onEnterKey(onClick)
      }, children), this.renderDescription());
    }
  }]);
}(_react.default.PureComponent);
(0, _defineProperty2.default)(ActionItem, "propTypes", {
  onClick: _propTypes.default.func,
  href: _propTypes.default.string,
  className: _propTypes.default.string,
  children: _propTypes.default.node,
  description: _propTypes.default.string,
  testId: _propTypes.default.string
});
var _default = exports.default = ActionItem;
//# sourceMappingURL=ActionItem.js.map